import styled from 'styled-components';
export const Wrapper = styled.a `
	display: inline-block;
	position: relative;
	z-index: 1000;
	height: ${p => p.$height}px;
`;
//# sourceMappingURL=styles.js.map